export enum TrafficAreaEnum {
    Undefined = 0,
    All = 1,
    Dicmo = 2,
    Drnis = 3,
    DugiRat = 4,
    Dugopolje = 5,
    Kastela = 6,
    Klis = 7,
    Lecevica = 8,
    Marina = 9,
    Muc = 10,
    Okrug = 11,
    Omis = 12,
    Podstrana = 13,
    Prgomet = 14,
    PrimorskiDolac = 15,
    Ruzic = 16,
    Seget = 17,
    Solin = 18,
    Split = 19,
    Sestanovac = 20,
    Solta = 21,
    Trilj = 22,
    Trogir = 23,
    Slatine = 24,
}
